import React from 'react'
import img1 from '../images/early.jpeg'
import img2 from '../images/boldizar.jpg'
import img3 from '../images/boldizar2.jpg'
const About = () => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-lg-6 mt-5'>
         
         <h4 className='bg-warning'> About Us:</h4>
          <p>
          Early Bird General Transport - A newly established company, powered by a team, highly professional staff with a combined experienced of over_ years in the industry. We are a privately owned company that provides top-notch clearing and forwarding solutions.
          </p>
          <p> Early Bird General Transport is an innovative general land transport company focused on the customers' preferences and needs for large capacity and flexibility, as well the secure storage, handling and transport of goods.</p>
          <p>We offer a range of value added services, such as free consulting to clients regarding a variety of customs processes and procedures and are guided by value principles that are applied in our daily operations.</p>
          <h4 className='bg-warning'> Mission Statement</h4>
          <p>Early Bird General Transport mission is to be a leading transportation company in UAE that provides land transportation support and solutions to our clients. We will strive this by directing on serving our client with quality competent work, on time delivery and with outmost value and ethics.</p>
          <h4 className='bg-warning'>Vision </h4>
          <p>Early Bird General Transport envisions to be the top choice and well trusted of the market within our Industry. We aim to be brought out a company that is well reputed that our client's can rely. In coming years, we intention to go worldwide and serve overseas </p>
          <h4 className='bg-warning'> Client Focus </h4>
          <p>Our client's satisfactory is always on the top list. We treat every client as VIP. We give value to every job that the client wants us to do. Our customer service team is primarily empowered by this value. They are expected to understand client's need and requirements. We take full responsibility along the procedure. We look in to every detail to make sure that we will meet our client's expectations. We consider every client as part of our growth and we look forward for repeat client and referrals, that's why building good relationship with our clients is very important.</p>
        </div>
        {/* col 2 */}
<div className='col-lg-6 mt-5'>
  <img  src={img1} alt='' /><hr />
  <img  src={img2} alt='' /><hr />
  <img  src={img3} alt='' />
</div>
      </div>
    </div>
  )
}

export default About